import { Injectable } from '@angular/core';
import { NavigationEnd, Router, RoutesRecognized } from '@angular/router';
import { BehaviorSubject } from 'rxjs';
import { filter, map, pairwise } from 'rxjs/operators';

@Injectable({
    providedIn: 'root',
})
export class RouteEventsService {
    public previousRoutePath = new BehaviorSubject<string>('');
    public currentRoutePath = new BehaviorSubject<string>('');

    constructor(private router: Router) {
        this.currentRoutePath.next(this.router.url);
        this.subscribeRouterEvents();
        this.getCurrentURL();
    }

    subscribeRouterEvents(): void {
        this.router.events
            .pipe(
                filter((e) => e instanceof RoutesRecognized),
                map((event) => event as RoutesRecognized),
                pairwise()
            )
            .subscribe((event: RoutesRecognized[]) => {
                this.previousRoutePath.next(event[0].urlAfterRedirects);
            });
    }

    getCurrentURL(): void {
        this.router.events
            .pipe(
                filter((e) => e instanceof NavigationEnd),
                map((event) => event as NavigationEnd)
            )
            .subscribe((event) => {
                this.currentRoutePath.next(event.url);
            });
    }

    get instant_previous_route_path(): string {
        return this.previousRoutePath.value;
    }

    get instant_current_route_path(): string {
        return this.currentRoutePath.value;
    }
}
